module.exports = __webpack_public_path__ + "static/media/select.1762f077.png";